import { ReactElement } from "react";
import PayInInstalmentIcon from "@Icons/PayInInstalmentIcon";
import CalendarClockIcon from "@Icons/CalendarClockIcon";
import CreditCardIcon from "@Icons/CreditCardIcon";
import TicketIcon from "@Icons/TicketIcon";
import DollarCircleIcon from "@Icons/DollarCircleIcon";
import CouncilTaxIcon from "@Icons/CouncilTaxIcon";
import PolicyCheckCircleIcon from "@Icons/PolicyCheckCircleIcon";
import PolicyFallbackIcon from "@Icons/PolicyFallbackIcon";
import PolicyIconContainer from "../../shared/PolicyIconContainer";
import { POLICY_ICON_PROPS } from "../../shared/policyIconConstants";

const normalizePolicyTag = (tag: string) =>
  tag?.toLowerCase().replace(/&/g, "and").replace(/\s+/g, "_").trim();

const wrapPolicyIcon = (icon: ReactElement) => <PolicyIconContainer>{icon}</PolicyIconContainer>;

export const getPaymentPolicyIcon = (tag: string) => {
  switch (normalizePolicyTag(tag)) {
    case "instalment_plans":
    case "instalment_plan":
    case "payment_instalment_plans":
    case "payment_instalment_plan":
      return wrapPolicyIcon(<CalendarClockIcon {...POLICY_ICON_PROPS} />);
    case "pay_in_instalment":
      return wrapPolicyIcon(<PayInInstalmentIcon {...POLICY_ICON_PROPS} />);
    case "mode_of_payment":
      return wrapPolicyIcon(<CreditCardIcon {...POLICY_ICON_PROPS} />);
    case "booking_deposit":
      return wrapPolicyIcon(<TicketIcon {...POLICY_ICON_PROPS} />);
    case "security_deposit":
      return wrapPolicyIcon(<PolicyCheckCircleIcon {...POLICY_ICON_PROPS} />);
    case "guarantor_requirement":
      return wrapPolicyIcon(<PolicyCheckCircleIcon {...POLICY_ICON_PROPS} />);
    case "additional_fees":
      return wrapPolicyIcon(<DollarCircleIcon {...POLICY_ICON_PROPS} />);
    case "council_tax":
      return wrapPolicyIcon(<CouncilTaxIcon {...POLICY_ICON_PROPS} />);
    default:
      return wrapPolicyIcon(<PolicyFallbackIcon {...POLICY_ICON_PROPS} />);
  }
};

export default getPaymentPolicyIcon;
